import { Box, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useNavigate, Navigate } from 'react-router-dom';

import { BorrowerCustomerProvidedVariables } from '../../../packages/borrowing-base/ui/BorrowerCustomerProvidedVariables';
import {
  InsightsTemplate,
  TAB_OPTION_KEYS,
} from 'packages/borrowing-base/ui/InsightsTemplate';
import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';

export const InsightsCustomerProvidedVariablesRoute = () => {
  const flags = useFeatureFlags();
  const toast = useToast();
  const navigate = useNavigate();

  if (flags.productsCustomerProvidedVariablesPermissions !== 'allow') {
    return <Navigate to="/" />;
  }

  // Use this variable for errors that bubble up to the component level route
  // This ensures we only toast the error once when there are multiple errors
  // We should use Chakra's toast.isActive, or a react hook in general, but the state re-renders when there are multiple errors in a given error boundary
  let routeLevelError = false;
  return (
    <Box>
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to load insights customer provided variables page`;
            routeLevelError = true;
            toast(errorToastConfig);
            navigate('/');
          }
        }}
      >
        <InsightsTemplate
          selectedTab={TAB_OPTION_KEYS.customerProvidedVariables}
        >
          <BorrowerCustomerProvidedVariables />
        </InsightsTemplate>
      </Sentry.ErrorBoundary>
    </Box>
  );
};
